import { machineConfig } from "machine/config";
import { services } from "./services";
import { actions } from "./actions";
import { guards } from "./guards";
import { TCheckoutContext, TCheckoutState, TCheckoutEvent } from "./types";
import { delays } from "./delays";

export const CheckOutMachine = machineConfig<
  TCheckoutContext,
  TCheckoutState,
  TCheckoutEvent
>(
  {
    id: "checkout",
    context: {
      orders: [],
      checksum: "",
      max_invoices: 0,
      paymentInfo: null,
      params: {
        CustomerID: "",
        TaxNumber: "",
      },
      invalid: {
        CustomerID: "",
        TaxNumber: "",
      },
      warnModal: "",
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          SET_CUSTOMER_ID: {
            actions: ["setCustomerId", "resetInvalidCustomerId"],
          },
          SET_TAX_NUMBER: {
            actions: ["setTaxNumber", "resetInvalidTaxNumber"],
          },
          TRIM_PARAMS: {
            actions: "trimParams",
          },
          NAVIGATE_TO_CHECKOUT: [
            {
              actions: "setInvalid",
              cond: "checkFormat",
            },
            {
              target: "fetching",
              actions: "navigateToCheckout",
            },
          ],
          FETCH_DATA: [
            {
              actions: ["redirectToLandingPage", "resetState"],
              cond: "checkEmptyFields",
            },
            {
              actions: ["redirectToLandingPage", "resetState"],
              cond: "checkFormat",
            },
            {
              target: "fetching",
            },
          ],
        },
      },
      fetching: {
        invoke: [
          {
            src: "getOrders",
            onDone: {
              target: "done",
              actions: "saveOrders",
            },
            onError: {
              target: "error",
            },
          },
        ],
      },
      done: {
        id: "done",
        on: {
          SELECT_INVOICE: [
            {
              actions: "setWarnModal",
              cond: "checkMaxInvoices",
            },
            {
              actions: "selectInvoice",
            }
          ],
          SELECT_ALL_INVOICES: [
            {
              actions: "setWarnModal",
              cond: "checkSelectAllMaxInvoices",
            },
            {
              actions: "selectAllInvoices",
            }
          ],
          CALL_PAYOO_PAYMENT: {
            target: "connect",
          },
        },
      },
      connect: {
        id: "connect",
        invoke: {
          src: "payOrders",
          onDone: {
            target: "redirecting",
            actions: "savePaymentInfo",
          },
          onError: {
            target: "done",
          },
        },
      },
      redirecting: {
        id: "redirecting",
        after: [
          {
            delay: "GOLINK",
            actions: "goLink",
            cond: "checkGolink",
          },
          {
            delay: "GOLINK_ERROR",
            target: "done",
            cond: "checkGolinkFailure",
          },
        ],
      },
      error: {
        id: "error",
      },
    },
    on: {
      CLOSE: {
        target: "done",
      },
      REDIRECT_TO_PAYOO_PAYMENT: [
        {
          actions: ["resetState", "setWarnModal"],
          cond: "checkPaymentUrlExpire",
        },
        {
          target: "redirecting",
          actions: "savePaymentInfo",
        },
      ],
      RESET_STATE: {
        target: "ready",
        actions: "resetState",
      },
      RESET_WARN_MODAL: {
        actions: "resetWarnModal",
      }
    },
  },
  {
    actions: actions,
    guards: guards,
    services: services,
    delays: delays,
  }
);
